import request from "@/utils/request";

// 测试任务列表信息
export function testingTaskPages(params) {
  return request({
    url: "/cloud/testing/taskPage",
    method: "post",
    data: params
  });
}

// 添加测试任务
export function createTestingTask(data) {
  return request({
    url: "/cloud/testing/task",
    method: "post",
    data: data
  });
}


// 测试任务车辆列表
export function testingTaskVehicleList(params) {
  return request({
    url: "/cloud/testing/task/vehiclePages",
    method: "post",
    data: params
  });
}

// 测试任务车辆信息
export function getTestingTaskVehicleInfo(testingTaskId) {
  return request({
    url: "/cloud/testing/task/vehicleInfo?testingTaskId=" + testingTaskId,
    method: "get"
  });
}
// 测试任务路线信息
export function getTestingTaskRouteInfo(testingTaskId) {
  return request({
    url: "/cloud/testing/task/routes?testingTaskId=" + testingTaskId,
    method: "get"
  });
}
